module.exports = __webpack_public_path__ + "static/media/giphy-5.4d46be49.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-5.gif
// module id = 176
// module chunks = 0